var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var tabsStyles = function (sticky) {
    var stickyProps = sticky
        ? {
            position: "sticky",
            top: 0,
            zIndex: 2,
        }
        : {};
    return __assign(__assign({}, stickyProps), { ".MuiTab-root": { textTransform: "none" }, ".MuiTabs-flexContainer": {
            gap: 2.5,
            position: "relative",
        }, overflow: "visible", ".MuiTabs-scroller": {
            overflow: "visible !important",
        } });
};
